import { createContext, useContext, useState, useEffect } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        // Avoid noisy 401s when no auth token/cookie is present
        const hasToken = localStorage.getItem("peppa_token") || document.cookie.includes("access_token");
        if (!hasToken) {
            setChecked(true);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setUser(null))
            .finally(() => setChecked(true));
    }, []);

    async function login(email, password) {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.access_token) localStorage.setItem("peppa_token", data.access_token);
        setUser(data.user);
        return data.user;
    }

    async function register(payload) {
        const { data } = await api.post("/auth/register", payload);
        if (data.access_token) localStorage.setItem("peppa_token", data.access_token);
        setUser(data.user);
        return data.user;
    }

    async function logout() {
        try {
            await api.post("/auth/logout");
        } catch {}
        localStorage.removeItem("peppa_token");
        setUser(null);
    }

    return (
        <AuthCtx.Provider value={{ user, checked, login, register, logout, setUser, formatApiError }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    return useContext(AuthCtx);
}
